<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item v-for="crumbs in breadCrumbs" :to="{ path: crumbs.path }">{{crumbs.name}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>

export default {
  name: 'BreadCrumbs',
  computed: {
    breadCrumbs() {
      return this.$store.state.BreadCrumbs.breadCrumbs;
    },
  },
};
</script>

<style scoped>

</style>
